import cms from "cms-request"
import {cmsConfig} from '../config/cmsConfig';

console.log('NODE_ENV', process.env.NODE_ENV)
console.log('cmsConfig', cmsConfig)
let cmsRequest = new cms.CmsH5Request(cmsConfig)

export default cmsRequest